import { useDisclosure } from "@mantine/hooks";
import {
  Drawer,
  Button,
  ScrollArea,
  Box,
  createStyles,
  Text,
  Accordion,
  Select,
  TextInput,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { IconChevronDown, IconDots, IconPlus } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { useForm } from "@mantine/form";

import swal from "sweetalert";

import {
  editProvider,
  getBillingProvider,
} from "../../services/billingprovider";

import { stateZipCodes } from "../../utils/zipCodes";

import ProviderServiceSearch from "./ProviderServiceSearch";

const useStyles = createStyles(() => ({
  mainbox: {
    background: "#FFFF",
    width: "100%",
    padding: "13px 19px",
    borderRadius: "16px",
    marginBottom: "20px",
    marginTop: "15px",
  },

  addbox: {
    // padding: "12px 12px 20px 30px",
    borderRadius: "12px",
    // border: "1px solid #E5E5EA",
    background: "#FFF",
  },

  formRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    "@media (max-width:1300px)": {
      flexDirection: "column",
      gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },
  },
  selectnumber: {
    width: "20%",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,

    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      borderRadius: "8px",
      // border: "1px solid #E5E5E5",
      border: "1px solid #D5D7DA",
      paddingInline: 0,
    },
  },

  selectbilling: {
    width: "70px",
    padding: "5px 5px",
    // borderRadius: "5px",
    backgroundColor: bgColor,
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selecttext: {
    width: "200px",
    padding: "5px 15px",
    // borderRadius: "5px",
    backgroundColor: bgColor,
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  addservicebtn: {
    // marginTop: "20px",
    width: "100%",
    borderRadius: "12px",
    border: "2px solid #E5E5E5",
    textAlign: "left",
    padding: "20px 26px",
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",

    "&:hover": {
      background: "rgba(255, 186, 69, 0.85)",
    },
  },

  widthbox: {
    width: "40%",
    "@media (max-width:1200px)": {
      width: "100%",
    },
  },

  button: {
    "&:hover": {
      background: "#FFAF4A",
      color: "#FFFFFF",
      opacity: 0.8,
    },
  },

  exitbutton: {
    "&:hover": {
      background: "#F9FAFB",
      color: "#1D2939",
      opacity: 0.8,
    },
  },

  container: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width: "40%",
  },
  boxWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
    padding: "8px 12px",
    backgroundColor: "#fff",
    width: "100%",
    height: "48px",
  },
  selectBilling: {
    width: "80px",
    minWidth: "80px",
    fontSize: "14px",
  },
  inputField: {
    flex: 1,
    fontSize: "14px",
    border: "none",
    padding: "0",
  },
  boxnumber: {
    display: "flex",
    flexDirection: "row",
    // width:'100%'
    // width: "min-content",
    // justifyContent:'flex-end'
  },

  servicesbox: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
  },

  boxsize: {
    width: "25px",
    // height:'10px',
    background: "#FFAF4A",
    padding: "2px 8px",
    borderRadius: "16px",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
  },

  addbtn: {
    display: "flex",
    justifyContent: "flex-end !important",
    marginTop: "18px",
    gap: "20px",
  },

  customBox: {
    backgroundColor: "#F5F5F5",
    //  paddingTop: '15px',
    "& .mantine-1ajh50z": {
      backgroundColor: "#F9FAFB",
    },
  },
}));
// const bgColor = "#D9D9D9";

const bgColor = "#FFFFFF";

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 15px",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",

      backgroundColor: bgColor,
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#94A3B8"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};
function EditProvider({
  editprovider,
  setEditProvider,
  item,
  isPreview,
  returnedFacility,
}) {
  console.log("🚀 ~ ====================> returnedFacility:", returnedFacility);
  const { classes } = useStyles();

  const handleClose = () => {
    // setIsPreview(false);
    setEditProvider(false);
  };

  // console.log('item',item);

  const { allservicecode } = useSelector((state) => state?.servicecode);
  const [selectedCode, setSelectedCode] = useState(item?.serviceCode || "");
  const [knownIllness, setKnownIllness] = useState(item?.services || []);
  const [isEditMode, setIsEditMode] = useState(true);
  const allfacilty = useSelector((state) => state.facility);
  console.log("🚀 ~ ====================> allfacilty:", allfacilty);
  const [knownIllnessField, setKnownIllnessField] = useState({
    servicetitle: "",
    servicenumber: "",
    servicechargetype: "",
    servicechargeNumber: "",
  });

  const [provider, setProvider] = useState(null);
  console.log("item", item);
  console.log("provider", provider);

  const handleSelectChange = (selectedOption) => {
    const selectedItem = allservicecode?.servicescode?.find(
      (item) => item.id === selectedOption
    );
    if (selectedItem) {
      setSelectedCode(selectedItem);
    }
  };

  // const form = useForm({
  //   initialValues: {
  //     name: "",
  //     serviceCode: "",
  //     procCode: "",
  //     taxonomy: "",
  //     address: "",
  //     address2: "",
  //     city: "",
  //     state: "",
  //     zipcode: "",
  //     federaltaxtype: "",
  //     federaltaxNumber: "",
  //     billingindentifiertype: "",
  //     billingindentifierNumber: "",
  //     // servicetitle: "",
  //     // servicenumber: "",
  //     servicechargetype: "",
  //     // servicechargeNumber: "",
  //   },
  // });

  const form = useForm({
    initialValues: {
      name: item?.name || "",
      taxonomy: item?.taxonomy || "",
      address: item?.address || "",
      address2: item?.address2 || "",
      phone: item?.phone,
      city: item?.city || "",
      state: item?.state || "",
      zipcode: item?.zipcode || "",
      federaltaxtype: item?.federalTaxID?.type || "",
      federaltaxNumber: item?.federalTaxID?.number || "",
      billingindentifiertype: item?.billingIdentifier?.type || "",
      billingindentifierNumber: item?.billingIdentifier?.number || "",
      providertype: item?.providertype || "",
    },
  });

  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    form.setValues({
      name: item?.name || "",
      taxonomy: item?.taxonomy || "",
      address: item?.address || "",
      address2: item?.address2 || "",
      city: item?.city || "",
      state: item?.state || "",
      zipcode: item?.zipcode || "",
      federaltaxtype: item?.federalTaxID?.type || "",
      federaltaxNumber: item?.federalTaxID?.number || "",
      billingindentifiertype: item?.billingIdentifier?.type || "",
      billingindentifierNumber: item?.billingIdentifier?.number || "",
      providertype: item?.providertype || "",
      phone: item?.phone,
    });
    setSelectedCode(item?.serviceCode || "");
    setKnownIllness(item?.services || []);
    setProvider(item?.facilityId?.id || null);
  }, [item]);

  const nextbtn = () => {
    console.log("currentStep", currentStep);

    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    } else {
      // setAddclient(false);
    }
  };

  // Define content for each step
  const renderContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <Accordion defaultValue="business-info">
              <Accordion.Item
                style={{
                  background: "#FFF",
                  borderRadius: "16px",
                  border: "1px solid #E5E5E5",
                }}
                value="business-info"
              >
                <Accordion.Control>
                  <Text ff={"Inter"} fz={16} fw={600} color="#3F3F46">
                    Business Information
                  </Text>
                </Accordion.Control>
                <Accordion.Panel>
                  <form>
                    <Box className={classes.addbox}>
                      {/* <Text
                      style={{ marginBottom: "32px" }}
                      ff={"Inter"}
                      fz={16}
                      fw={600}
                      color="#171717"
                    >
                      Business Information
                    </Text> */}

                      <div className={classes.formRow}>
                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            Provider Type
                          </Text>
                          <CustomSelectBox
                            disabled={isPreview}
                            id="billing-type"
                            placeholder={"Type"}
                            withAsterisk
                            data={[
                              { value: "facility", label: "Facility" },
                              { value: "individual", label: "Individual" },
                            ]}
                            {...form.getInputProps("providertype")}
                          />
                        </Box>
                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            Provider Name
                          </Text>

                          {/* medication name */}
                          <CustomTextInput
                            id="medication-name"
                            // label={"Facility Name"}
                            disabled={isPreview}
                            size="sm"
                            // placeholder={"Enter Medication Name"}
                            // {...form.getInputProps("medicationName")}
                            withAsterisk
                            // disabled={isPreview}
                            {...form.getInputProps("name")}
                          />
                        </Box>
                      </div>

                      <div className={classes.formRow}>
                        {/* <Box>
                        <Text ff={"Inter"} fz={14} fw={500} color="#414651">
                          Phone Number
                        </Text>
    
                        <Box  className={classes.boxnumber}>
                          <Select
                            id="billing-type"
                            className={classes.selectnumber}
                            value={"+1"}
                            withAsterisk
                            disabled
                            data={[
                              { value: "+1", label: "+1" },
                          
                            ]}
                            onChange={(value) =>
                              form.setFieldValue(
                                "phone",
                                value + form?.values?.phone?.slice(2)
                              )
                            }
                          />
    
                 
                          <TextInput
                            className={classes.selecttext}
                            id="billing-name"
                            type="number"
                            size="sm"
                            placeholder={"Number"}
                            withAsterisk
                            onChange={(e) =>
                              form.setFieldValue(
                                "phone",
                                form.values?.phone?.substring(0, 2) + e.target.value
                              )
                            }
                            {...form.getInputProps("phone")}
                          />
                        </Box>
                      </Box> */}

                        <Box className={classes.container}>
                          <Text ff="Inter" fz={14} fw={500} color="#344054">
                            Phone Number
                          </Text>

                          <Box className={classes.boxWrapper}>
                            <Select
                              style={{ width: "10px" }}
                              disabled={isPreview}
                              className={classes.selectBilling}
                              rightSection={
                                <IconChevronDown color={"#94A3B8"} size={20} />
                              }
                              id="billing-type"
                              variant="unstyled"
                              value={"+1"}
                              withAsterisk
                              readOnly
                              data={[{ value: "+1", label: "+1" }]}
                              onChange={(value) =>
                                form.setFieldValue(
                                  "phone",
                                  value + form?.values?.phone?.slice(2)
                                )
                              }
                            />

                            <TextInput
                              className={classes.inputField}
                              id="billing-name"
                              type="number"
                              disabled={isPreview}
                              size="sm"
                              placeholder={"Number"}
                              variant="unstyled"
                              withAsterisk
                              onChange={(e) =>
                                form.setFieldValue(
                                  "phone",
                                  form.values?.phone?.substring(0, 2) +
                                    e.target.value
                                )
                              }
                              {...form.getInputProps("phone")}
                            />
                          </Box>
                        </Box>

                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            Place of Service Name
                          </Text>
                          <Box className={classes.boxnumber}>
                            <CustomSelectBox
                              id="billing-type"
                              placeholder={"Type"}
                              disabled={isPreview}
                              withAsterisk
                              searchable
                              data={(allservicecode &&
                              allservicecode.servicescode
                                ? allservicecode.servicescode
                                : []
                              )
                                .map((item) => ({
                                  value: item?.id,
                                  label: item?.name,
                                }))
                                .sort((a, b) => a.label.localeCompare(b.label))}
                              value={selectedCode?.id}
                              onChange={handleSelectChange}
                              // {...form.getInputProps("serviceCode")}
                            />
                            {/* 
                            <Box className={classes.line}></Box> */}
                          </Box>
                        </Box>
                      </div>

                      <Box className={classes.mt19}>
                        <div className={classes.formRow}>
                          <Box className={classes.widthbox}>
                            <Text ff={"Inter"} fz={14} fw={500} color="#414651">
                              Code
                            </Text>
                            <CustomSelectBox
                              placeholder={"Number"}
                              disabled={isPreview}
                              withAsterisk
                              searchable
                              data={(allservicecode &&
                              allservicecode.servicescode
                                ? allservicecode.servicescode
                                : []
                              )
                                .map((item) => ({
                                  value: item?.id,
                                  label: item?.code,
                                }))
                                .sort((a, b) => {
                                  const numA = Number(a.label);
                                  const numB = Number(b.label);
                                  return numA - numB;
                                })}
                              value={selectedCode?.id}
                              onChange={handleSelectChange}
                            />
                          </Box>

                          <Box
                            className={`${classes.mt19} ${classes.widthbox}`}

                            // className={classes.mt19 }
                          >
                            <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                              Facility
                            </Text>
                            <CustomSelectBox
                              id="billing-type"
                              withAsterisk
                              data={
                                returnedFacility
                                  ? allfacilty?.allFacilities?.facilities
                                      ?.filter((f) => f.id === returnedFacility)
                                      ?.map((f) => ({
                                        value: f.id,
                                        label: f.name,
                                      })) || []
                                  : allfacilty?.allFacilities?.facilities?.map(
                                      (item) => ({
                                        value: item.id,
                                        label: item.name,
                                      })
                                    ) || []
                              }
                              // data={
                              //   returnedFacility
                              //     ? [
                              //         {
                              //           value: returnedFacility?.id,
                              //           label: returnedFacility?.name,
                              //         },
                              //       ]
                              //     : (allfacilty &&
                              //       allfacilty?.allFacilities?.facilities
                              //         ? allfacilty?.allFacilities?.facilities
                              //         : []
                              //       ).map((item) => ({
                              //         value: item?.id,
                              //         label: item?.name,
                              //       }))
                              // }
                              // data={(allfacilty &&
                              // allfacilty?.allFacilities?.facilities
                              //   ? allfacilty?.allFacilities?.facilities
                              //   : []
                              // ).map((item) => ({
                              //   value: item?.id,
                              //   label: item?.name,
                              // }))}
                              value={provider}
                              onChange={(value) => setProvider(value)}
                            />
                          </Box>
                        </div>

                        <div className={classes.formRow}>
                          <Box className={classes.container}>
                            <Text ff="Inter" fz={14} fw={500} color="#344054">
                              Federal Tax ID
                            </Text>

                            <Box className={classes.boxWrapper}>
                              <Select
                                className={classes.selectBilling}
                                id="billing-type"
                                disabled={isPreview}
                                placeholder="Type"
                                rightSection={
                                  <IconChevronDown
                                    color={"#94A3B8"}
                                    size={20}
                                  />
                                }
                                withAsterisk
                                variant="unstyled"
                                data={[
                                  { value: "SSN", label: "SSN" },
                                  { value: "EIN", label: "EIN" },
                                ]}
                                {...form.getInputProps("federaltaxtype")}
                              />

                              <TextInput
                                className={classes.inputField}
                                id="billing-name"
                                disabled={isPreview}
                                type="number"
                                size="sm"
                                placeholder="000-000-000"
                                withAsterisk
                                variant="unstyled"
                                {...form.getInputProps("federaltaxNumber")}
                              />
                            </Box>
                          </Box>

                          <Box className={classes.widthbox}>
                            <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                              Taxonomy/Speciality
                            </Text>

                            <CustomTextInput
                              id="medication-name"
                              disabled={isPreview}
                              // label={"Taxonomy/Speciality"}
                              size="sm"
                              // placeholder={"Enter Medication Name"}
                              // {...form.getInputProps("medicationName")}
                              withAsterisk
                              {...form.getInputProps("taxonomy")}
                              // disabled={isPreview}
                            />
                          </Box>

                          {/* Second Box */}
                        </div>

                        <Box
                          // style={{ width: "100%" }}
                          className={classes.container}
                        >
                          <Text ff="Inter" fz={14} fw={500} color="#344054">
                            Billing Identifier
                          </Text>

                          <Box className={classes.boxWrapper}>
                            <Select
                              className={classes.selectBilling}
                              disabled={isPreview}
                              id="billing-type"
                              rightSection={
                                <IconChevronDown color={"#94A3B8"} size={20} />
                              }
                              variant="unstyled"
                              placeholder="Type"
                              withAsterisk
                              data={[
                                { value: "NPI", label: "NPI" },
                                { value: "#", label: "#" },
                              ]}
                              {...form.getInputProps("billingindentifiertype")}
                            />

                            <TextInput
                              className={classes.inputField}
                              disabled={isPreview}
                              id="billing-name"
                              type="number"
                              size="sm"
                              placeholder="000-000-000"
                              withAsterisk
                              variant="unstyled"
                              {...form.getInputProps(
                                "billingindentifierNumber"
                              )}
                            />
                          </Box>
                        </Box>

                        <Text
                          style={{ marginTop: "10px" }}
                          disabled={isPreview}
                          ff={"Inter"}
                          fz={14}
                          fw={500}
                          color="#344054"
                        >
                          Address 1
                        </Text>

                        {/* medication name */}
                        <CustomTextInput
                          id="medication-name"
                          disabled={isPreview}
                          // label={"Facility Name"}
                          size="sm"
                          // placeholder={"Enter Medication Name"}
                          // {...form.getInputProps("medicationName")}
                          withAsterisk
                          {...form.getInputProps("address")}
                          // disabled={isPreview}
                        />
                      </Box>

                      <Box className={classes.mt19} mt={10}>
                        <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                          Address 2
                        </Text>

                        {/* medication name */}
                        <CustomTextInput
                          id="medication-name"
                          // label={"Facility Name"}
                          size="sm"
                          // placeholder={"Enter Medication Name"}
                          // {...form.getInputProps("medicationName")}
                          {...form.getInputProps("address2")}
                          disabled={isPreview}
                          withAsterisk
                          // disabled={isPreview}
                        />
                      </Box>

                      <div
                        style={{ marginTop: "19px" }}
                        className={classes.formRow}
                      >
                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            City
                          </Text>

                          {/* medication name */}
                          <CustomTextInput
                            id="medication-name"
                            // label={"Facility Name"}
                            {...form.getInputProps("city")}
                            disabled={isPreview}
                            size="sm"
                            // placeholder={"Enter Medication Name"}
                            // {...form.getInputProps("medicationName")}
                            withAsterisk
                            // disabled={isPreview}
                          />
                        </Box>

                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            State
                          </Text>

                          <CustomSelectBox
                            id="state"
                            size="sm"
                            withAsterisk
                            disabled={isPreview}
                            data={Array.from(
                              new Set(stateZipCodes?.map((obj) => obj.ste_name))
                            )
                              .sort()
                              .map((ste_name) => ({
                                value: ste_name,
                                label: ste_name,
                              }))}
                            {...form.getInputProps("state")}
                            searchable
                          />
                        </Box>
                      </div>

                      <div
                        style={{ marginTop: "19px" }}
                        className={classes.formRow}
                      >
                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            Zip Code
                          </Text>

                          <CustomTextInput
                            id="zip-code"
                            type="number"
                            disabled={isPreview}
                            // label={"Facility Name"}
                            {...form.getInputProps("zipcode")}
                            size="sm"
                            // placeholder={"Enter Medication Name"}
                            // {...form.getInputProps("medicationName")}
                            withAsterisk
                            // disabled={isPreview}
                          />
                        </Box>
                      </div>

                      {/* <Box    onClick={nextbtn}   className={classes.addservicebtn}>
    
                      <Text ff={"Inter"} fz={16} fw={600} color="#3F3F46" >+ Add Providers Service</Text>
                  
                  
    
                       <img
                    width={20}
                    src="/assets/images/newserviceframe.png"
                    alt="back-icon"
                  />
               
                    </Box> */}
                    </Box>
                  </form>
                </Accordion.Panel>
              </Accordion.Item>
            </Accordion>

            <Accordion style={{ marginTop: "24px" }}>
              <Accordion.Item
                style={{
                  background: "#FFF",
                  borderRadius: "16px",
                  border: "1px solid #E5E5E5",
                }}
                value="provider-service-details"
              >
                <Accordion.Control>
                  <Box className={classes.servicesbox}>
                    {knownIllness.length > 0 ? (
                      <img
                        width={20}
                        height={20}
                        // style={{ position: "relative", top: "29%" }}
                        src="/assets/images/Check icon.png"
                        alt="check-icon"
                      />
                    ) : null}

                    <Text ff={"Inter"} fz={16} fw={600} color="#171717">
                      Provider Service Details
                    </Text>

                    {knownIllness.length > 0 ? (
                      <Box className={classes.boxsize}>
                        <Text
                          ta="center"
                          ff={"Inter"}
                          fz={12}
                          fw={500}
                          color="#000"
                        >
                          {knownIllness?.length}
                        </Text>
                      </Box>
                    ) : null}
                  </Box>
                </Accordion.Control>
                <Accordion.Panel>
                  <form>
                    <ProviderServiceSearch
                      existingServices={knownIllness}
                      setExistingServices={setKnownIllness}
                      activeService={knownIllnessField}
                      setActiveService={setKnownIllnessField}
                      isEditMode={isEditMode}
                      setIsEditMode={setIsEditMode}
                    />
                  </form>
                </Accordion.Panel>
              </Accordion.Item>
            </Accordion>
          </>
        );

      default:
        return null;
    }
  };

  const onSave = async (_) => {
    try {
      const values = form.values;
      let missingFields = [];
      if (!selectedCode) missingFields.push("Place of Service Name");
      Object.entries(values)
        .filter(([key, _]) => key !== "address2")
        .forEach(([key, value]) => !value && missingFields.push(key));
      if (knownIllness.length < 1) missingFields.push("Service");
      if (missingFields.length > 0) {
        await swal({
          title: "Please fill out the following fields",
          text: missingFields.join(", "),
          icon: "warning",
          dangerMode: true,
        });
        return;
      }

      const selectedState = values.state?.trim();
      const enteredZipCode = values.zipcode?.trim();
      if (selectedState && enteredZipCode) {
        const stateZipCodeEntries = stateZipCodes.filter(
          (entry) => entry.ste_name === selectedState
        );

        const isZipValid = stateZipCodeEntries.some(
          (entry) => entry.zip_code === enteredZipCode
        );

        if (!isZipValid) {
          await swal({
            title: "Invalid Zip Code",
            text: `The zip code you entered is not valid for ${selectedState}. Please enter a valid zip code.`,
            icon: "warning",
            dangerMode: true,
          });
          return;
        }
      }

      const {
        federaltaxtype,
        federaltaxNumber,
        billingindentifiertype,
        billingindentifierNumber,
        ...restValues
      } = values;

      // profile.user.id

      let payload = {
        ...restValues,
        federalTaxID: {
          type: federaltaxtype,
          number: federaltaxNumber,
        },
        billingIdentifier: {
          type: billingindentifiertype,
          number: billingindentifierNumber,
        },
        services: knownIllness?.map((service) => {
          return {
            servicetitle: service?.servicetitle,
            servicenumber: service?.servicenumber,
            servicechargetype: service?.servicechargetype,
            // servicechargeNumber: service?.servicechargeNumber,
          };
        }),
        serviceCode: selectedCode?.id,
        facilityId: provider,
        id: item.id,
      };

      console.log("payload", payload);

      const addFacilityResponse = await editProvider({
        ...payload,
      });

      if (addFacilityResponse?.status === 200) {
        let payload = {
          page: 1,
        };
        getBillingProvider(payload);
        swal({
          title: `facilty update successfully`,
          text: "facilty update successfully",
          dangerMode: false,
        });

        handleClose();

        // await getAllFacilitiesModal();
      }

      // }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <Drawer
        offset={8}
        radius="md"
        // size="40%"
        size="50%"
        zIndex={1000}
        // title="Add Provider"
        title={
          <span style={{ fontSize: "24px", fontWeight: "700", color: "#000" }}>
            Edit Provider
          </span>
        }
        sx={{
          ".mantine-1fholi4": {
            color: "#000",
          },
          ".mantine-1fholi4:hover": {
            color: "#FFAF4A",
          },
        }}
        opened={editprovider}
        onClose={handleClose}
        position="right"
        className={classes.customBox}
        scrollAreaComponent={ScrollArea.Autosize}
        overlayProps={{ backgroundOpacity: 2.5, blur: 4 }}
      >
        <Box className={classes.mainbox}>{renderContent()}</Box>
        <div className={classes.addbtn}>
          <Button
            className={classes.exitbutton}
            onClick={handleClose}
            variant="filled"
            c="#1D2939"
            radius="md"
            size="md"
            bg="#FFF"
          >
            Cancel
          </Button>

          <Button
            className={classes.button}
            disabled={isPreview || knownIllness.length <= 0}
            onClick={onSave}
            // type="submit"
            variant="filled"
            c="#1D2939"
            radius="md"
            size="md"
            bg="#FFAF4A"
          >
            Save And Continue
          </Button>
        </div>
      </Drawer>
      {/* </Modal> */}
    </>
  );
}

export default EditProvider;
